import React from 'react'
const TopNavbar = () => {
  return (
    <>
      {/* <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'end', padding: '10px' }}>
        <button>
          settings icon
        </button>
        <button>
          user icon
        </button>
      </div> */}
    </>
  )
}


export default TopNavbar